import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 're-select',
  templateUrl: './re-select.component.html',
  styleUrls: ['./re-select.component.scss'],
})
export class ReSelectComponent implements OnInit {
  @Input() module: any;
  @Input() placeholder: any = 'Search Response';
  @Input() style: any;
  @Output() onUpdate = new EventEmitter<any>();
  @Input() selected_ids: any = null;

  input$ = new Subject<string>();
  result_list = [];

  constructor(private api: ApiService) {}

  ngOnInit() {
    this.onSearch();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selected_ids']) {
      if (this.selected_ids?.length > 0) {
        this.api
          .get(
            `/search-data?office_id=${this.api.getOfficeId()}&filter=${JSON.stringify([this.selected_ids])}&Keywords=&module=${this.module}&page=1&limit=40`
          )
          .subscribe({
            next: res => {
              this.result_list = this.prepareResult(res.data, this.getField());
            },
          });
      }
    }
  }

  onSearch() {
    this.input$
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(term =>
          this.api.get(
            `/search-data?office_id=${this.api.getOfficeId()}&user_id=${this.api.getOfficeId()}&Keywords=${term}&module=${this.module}&page=1&limit=20`
          )
        )
      )
      .subscribe(res => {
        this.result_list = this.prepareResult(res.data, this.getField());
      });
  }

  getField = () => {
    if (['users', 'contacts', 'leads'].includes(this.module)) {
      return 'full_name';
    }

    if (['listings', 'property'].includes(this.module)) {
      return 'property_address';
    }

    if (['projects'].includes(this.module)) {
      return 'Project_Name';
    }

    if (['tasks'].includes(this.module)) {
      return 'title';
    }

    return 'name';
  };

  prepareResult = (items: any[], field: string) => {
    let f = [];
    items.forEach(c => {
      f.push({
        _id: c._id,
        name: c[field],
      });
    });
    return f;
  };

  onSelection(e) {
    this.onUpdate.emit(e?._id ? e?._id : null);
  }

  getStyle = (style: any) => {
    let newStyle: any = { ...style };
    return newStyle;
  };
}
